import type { CauserSubjectItem } from "./causer-subject.type";
import type { ModelKey } from "@/modules/model";

import { getModelRoute } from "@/modules/model";

export const getCauserSubjectRoute = (
  model?: ModelKey,
  item?: CauserSubjectItem
) => {
  if (!model || !item || item.deleted_at !== null) return undefined;

  const route = getModelRoute(model);

  if (!route) return undefined;

  return `${route}/${item.id}`;
};
